import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { HttpService } from '../http.service';
import { map } from 'rxjs/operators';

export interface CompanyProfileStatus {
    completed: boolean;
    completed_at: string | null;
    business_sector_code: string | null;
    business_sector_name: string | null;
    employee_count: string | null;
    user_job_title: string | null;
}

export interface BusinessSector {
    code: string;
    name: string;
}

export interface EmployeeCount {
    value: string;
    label: string;
}

export interface JobTitle {
    value: string;
    label: string;
}

export interface CompanyProfileOptions {
    business_sectors: BusinessSector[];
    employee_counts: EmployeeCount[];
    job_titles: JobTitle[];
}

export interface CompanyProfilePayload {
    business_sector_code: string;
    employee_count: string;
    user_job_title: string;
}

export interface CompanyProfileResponse {
    success: boolean;
    message?: string;
    data: CompanyProfileStatus;
}

@Injectable({
    providedIn: 'root'
})
export class CompanyProfileService {

    constructor(
        private httpService: HttpService
    ) { }

    /**
     * Get company profile status and data
     */
    getStatus(): Observable<CompanyProfileStatus> {
        return this.httpService.get('/v1/clients/company-profile/status').pipe(
            map(res => res.data as CompanyProfileStatus)
        );
    }

    /**
     * Get available options for company profile fields
     */
    getOptions(): Observable<CompanyProfileOptions> {
        return this.httpService.get('/v1/clients/company-profile/options').pipe(
            map(res => res.data as CompanyProfileOptions)
        );
    }

    /**
     * Store company profile data
     */
    store(payload: CompanyProfilePayload): Observable<CompanyProfileResponse> {
        return this.httpService.post('/v1/clients/company-profile', payload).pipe(
            map(res => res as CompanyProfileResponse)
        );
    }
}
